import { all } from 'redux-saga/effects'

import { updateSaga } from './update/saga'

export function* employerSaga() {
  yield all([updateSaga()])
}
